export default __webpack_public_path__ + "static/india_idpdpc.webp";